module.exports = __webpack_public_path__ + "img/selectIc.png";